import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { AppThemeProvider } from './theme';
/* Bootstrap: legacy screens — bridge CSS aligns with tokens; migrate to MUI incrementally */
import 'bootstrap/dist/css/bootstrap.min.css';
import './theme/global.css';
import './theme/bootstrap-bridge.css';

function App() {
  return (
    <AppThemeProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AppThemeProvider>
  );
}

export default App;
